import { ComputedRef } from 'vue'

import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'
import { EditorPageStateViewModel } from '@/presentation/viewmodels/editor/editorPageStateViewModel'
import { JudgeStateViewModel } from '@/presentation/viewmodels/judge/judgeStateViewModel'
import { PostSubmissionViewModel } from '@/presentation/viewmodels/judge/postSubmissionViewModel'
import { NotificationViewModel } from '@/presentation/viewmodels/notification/notificationViewModel'
import { store } from '@/store'

export class PostSubmissionPresenter {
  private viewModel: PostSubmissionViewModel
  private editorPageStateViewModel: EditorPageStateViewModel
  private notificationViewModel: NotificationViewModel
  private judgeStateViewModel: JudgeStateViewModel

  constructor(
    viewModel: PostSubmissionViewModel,
    editorPageStateViewModel: EditorPageStateViewModel = new EditorPageStateViewModel(),
    notificationViewModel: NotificationViewModel = new NotificationViewModel(store),
    judgeStateViewModel: JudgeStateViewModel = new JudgeStateViewModel()
  ) {
    this.viewModel = viewModel
    this.editorPageStateViewModel = editorPageStateViewModel
    this.notificationViewModel = notificationViewModel
    this.judgeStateViewModel = judgeStateViewModel
  }

  get judgeToken(): ComputedRef<string> {
    return this.viewModel.judgeToken
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async postSubmission(problemId: string, programLanguage: ProgramLanguageType, sourceCode: string): Promise<void> {
    // エラーを非表示
    this.editorPageStateViewModel.setIsErrorShow(false)

    // 通知を表示
    await this.notificationViewModel.openRunning({
      type: 'Judge',
      showFreeSpaceModal: false,
      problemId: problemId
    })

    // テスト実行中の状態に変更
    await this.judgeStateViewModel.setIsJudgeNotificationLoading(true)
    await this.judgeStateViewModel.setIsJudgeLoading(true)

    await this.viewModel.postSubmission(problemId, programLanguage, sourceCode)
  }
}
